import {
  Box,
  Button,
  Card,
  Checkbox,
  Container,
  FormControl,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Avatar,
  Chip,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { getContractProperties } from '../../helper/backend_helper';
import appConfig from '../../config';

const ContractDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const contractData = location?.state?.userData;
  console.log('contractData', contractData);
  const [properties, setProperties] = useState([]);
  console.log('properties', properties);
  async function fetchData() {
    try {
      const res = await getContractProperties(contractData?._id);
      setProperties(res?.data?.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Helmet>
        <title>Contract Detail - {contractData?.name}</title>
      </Helmet>
      <Container maxWidth="xl" sx={{ py: 4 }}>
        {/* Header Section */}
        <Card sx={{ p: 3, mb: 4, boxShadow: 3 }}>
          {/* Header */}
          <Stack direction="row" alignItems="center" spacing={2} sx={{ cursor: 'pointer', mb: 2 }}>
            <FaArrowLeftLong onClick={() => navigate(-1)} size={24} />
            <Typography variant="h4" color="primary">
              {contractData?.name}
            </Typography>
          </Stack>

          {/* Contract Overview */}
          <Grid container spacing={3}>
            {/* Contract Details */}
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom>
                Contract Details
              </Typography>
              <List dense>
                <ListItem>
                  <ListItemText primary="Contract ID" secondary={contractData?._id} />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Status"
                    secondary={
                      <Chip
                        label={contractData?.isSubmitted ? 'Submitted' : 'Pending'}
                        color={contractData?.isSubmitted ? 'success' : 'warning'}
                        size="small"
                      />
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Language" secondary={contractData?.language} />
                </ListItem>

                <ListItem>
                  <ListItemText primary="Privacy Accepted" secondary={contractData?.privacyAccepted ? 'Yes' : 'No'} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Duration" secondary={contractData?.contractDuration} />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Created At"
                    secondary={new Date(contractData?.createdAt).toLocaleDateString()}
                  />
                </ListItem>

                <ListItem>
                  <ListItemText primary="Owner Type" secondary={contractData?.ownerType} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Percentage" secondary={contractData?.percentage} />
                </ListItem>
              </List>
            </Grid>

            {/* Bank Information */}
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom>
                Bank Information
              </Typography>
              <List dense>
                <ListItem>
                  <ListItemText primary="Account Holder" secondary={contractData?.bankInfo?.accountHolder} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Bank" secondary={contractData?.bankInfo?.bank} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="IBAN" secondary={contractData?.bankInfo?.iban} />
                </ListItem>
              </List>
            </Grid>

            {/* Company Information */}
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom>
                Company Information
              </Typography>
              <List dense>
                <ListItem>
                  <ListItemText primary="Company Name" secondary={contractData?.companyInfo?.companyName} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Company Type" secondary={contractData?.companyInfo?.companyType} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Email" secondary={contractData?.companyInfo?.email} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="PEC" secondary={contractData?.companyInfo?.pec} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="VAT Number" secondary={contractData?.companyInfo?.vatNumber} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Fiscal Code" secondary={contractData?.companyInfo?.fiscalCode} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Country" secondary={contractData?.companyInfo?.country} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="City" secondary={contractData?.companyInfo?.city} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Legal Address" secondary={contractData?.companyInfo?.legalAddress} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Street Number" secondary={contractData?.companyInfo?.streetNumber} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Postal Code" secondary={contractData?.companyInfo?.postalCode} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Province" secondary={contractData?.companyInfo?.province} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Phone" secondary={contractData?.companyInfo?.phone} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Phone Code" secondary={contractData?.companyInfo?.phoneCode} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="REA Number" secondary={contractData?.companyInfo?.reaNumber} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Tax Status" secondary={contractData?.companyInfo?.taxStatus} />
                </ListItem>
                <ListItem style={{ display: 'flex',flexDirection: 'column', alignItems: 'flex-start' }} >
                  <ListItemText primary="Visura Societaria" />
               
                  {contractData?.companyInfo?.visuraSocietaria?.map((imgName, index) => (
                    <a
                      key={index}
                      href={`${appConfig.FILE_URL}${imgName}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ marginRight: '8px', color: 'blue', textDecoration: 'underline' }} // optional styling
                    >
                      Link
                    </a>
                  ))}
                 
                </ListItem>

                <ListItem>
                  <ListItemText
                    primary="Electronic Invoice Code"
                    secondary={contractData?.companyInfo?.electronicInvoiceCode}
                  />
                </ListItem>
              </List>
            </Grid>

            {/* Company Owner */}
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom>
                Company Owner
              </Typography>
              <List dense>
                <ListItem>
                  <ListItemText primary="First Name" secondary={contractData?.companyOwner?.firstName} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Last Name" secondary={contractData?.companyOwner?.lastName} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Gender" secondary={contractData?.companyOwner?.gender} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Birth Date" secondary={contractData?.companyOwner?.birthDate} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Birth Place" secondary={contractData?.companyOwner?.birthPlace} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Position" secondary={contractData?.companyOwner?.position} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Fiscal Code" secondary={contractData?.companyOwner?.fiscalCode} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Country" secondary={contractData?.companyOwner?.country} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Phone Code" secondary={contractData?.companyOwner?.phoneCode} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Document Type" secondary={contractData?.companyOwner?.documentType} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Document Number" secondary={contractData?.companyOwner?.documentNumber} />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Issue Date"
                    secondary={contractData?.companyOwner?.documentDetails?.issueDate}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Expiry Date"
                    secondary={contractData?.companyOwner?.documentDetails?.expiryDate}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Issued By" secondary={contractData?.companyOwner?.documentDetails?.issuedBy} />
                </ListItem>
                {/* <ListItem>
                  <ListItemText
                    primary="Document Copy"
                    secondary={contractData?.companyOwner?.documentCopy?.join(', ')}
                  />
                </ListItem> */}


                <ListItem style={{ display: 'flex',flexDirection: 'column', alignItems: 'flex-start' }} >
                  <ListItemText primary="Document Copy" />
               
                  {contractData?.companyOwner?.documentCopy?.map((imgName, index) => (
                    <a
                      key={index}
                      href={`${appConfig.FILE_URL}${imgName}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ marginRight: '8px', color: 'blue', textDecoration: 'underline' }} // optional styling
                    >
                      Link
                    </a>
                  ))}
                 
                </ListItem>
                {/* <ListItem>
                  <ListItemText
                    primary="Fiscal Code Copy"
                    secondary={contractData?.companyOwner?.fiscalCodeCopy?.join(', ')}
                  />
                </ListItem> */}
                <ListItem style={{ display: 'flex',flexDirection: 'column', alignItems: 'flex-start' }} >
                  <ListItemText primary="Fiscal Code Copy" />
               
                  {contractData?.companyOwner?.fiscalCodeCopy?.map((imgName, index) => (
                    <a
                      key={index}
                      href={`${appConfig.FILE_URL}${imgName}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ marginRight: '8px', color: 'blue', textDecoration: 'underline' }} // optional styling
                    >
                      Link
                    </a>
                  ))}
                 
                </ListItem>
              </List>
            </Grid>

            {/* Payment Information */}
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom>
                Payment Information
              </Typography>
              <List dense>
                <ListItem>
                  <ListItemText
                    primary="Management Fee Percentage"
                    secondary={contractData?.paymentInfo?.managementFeePercentage}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Owner Signature"
                  />
                    <img id="base64image" alt="Signature" src={contractData?.paymentInfo?.ownerSignature} className='h-40' />
                </ListItem>
              </List>
            </Grid>

            {/* Private Owner */}
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom>
                Private Owner
              </Typography>
              <List dense>
                <ListItem>
                  <ListItemText primary="First Name" secondary={contractData?.privateOwner?.firstName || 'N/A'} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Last Name" secondary={contractData?.privateOwner?.lastName || 'N/A'} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Gender" secondary={contractData?.privateOwner?.gender || 'N/A'} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Birth Date" secondary={contractData?.privateOwner?.birthDate || 'N/A'} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Country" secondary={contractData?.privateOwner?.country} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Phone Code" secondary={contractData?.privateOwner?.phoneCode} />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Document Type" secondary={contractData?.privateOwner?.documentType || 'N/A'} />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Document Number"
                    secondary={contractData?.privateOwner?.documentNumber || 'N/A'}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Issue Date"
                    secondary={contractData?.privateOwner?.documentDetails?.issueDate || 'N/A'}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Expiry Date"
                    secondary={contractData?.privateOwner?.documentDetails?.expiryDate || 'N/A'}
                  />
                </ListItem>
              </List>
            </Grid>

            {/* Signature Files */}
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Signature Files
              </Typography>
              {/* <List dense>
                <ListItem>
                  <ListItemText primary="Files" secondary={contractData?.signatureFile?.join(', ')} />
                </ListItem>
              </List> */}
              <ListItem style={{ display: 'flex',flexDirection: 'column', alignItems: 'flex-start' }} >
                  <ListItemText primary="Files" />
               
                  {contractData?.signatureFile?.map((imgName, index) => (
                    <a
                      key={index}
                      href={`${appConfig.FILE_URL}${imgName}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ marginRight: '8px', color: 'blue', textDecoration: 'underline' }} // optional styling
                    >
                      Link
                    </a>
                  ))}
                 
                </ListItem>
            </Grid>
          </Grid>
        </Card>

        {/* Properties Section */}
        <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
          Associated Properties ({properties.length})
        </Typography>
        {/* <Grid container spacing={3}>
          {properties.map((property) => (
            <Grid item xs={12} md={6} lg={4} key={property._id}>
              <Card sx={{ p: 2, height: '100%', boxShadow: 2 }}>
                <Typography variant="h6" color="primary" gutterBottom>
                  {property.name}
                </Typography>
                <Divider sx={{ mb: 2 }} />
                <Stack spacing={1}>
                  <Typography variant="body2">
                    <strong>Address:</strong> {property.address}, {property.city}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Size:</strong> {property.size} m²
                  </Typography>
                  <Typography variant="body2">
                    <strong>Max Guests:</strong> {property.maxGuests}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Amenities:</strong>
                    <Box sx={{ mt: 1 }}>
                      {property.amenities
                        .filter((amenity) => amenity.selected)
                        .map((amenity) => (
                          <Chip
                            key={amenity._id}
                            label={amenity.name.en}
                            size="small"
                            sx={{ mr: 1, mb: 1 }}
                            color="primary"
                            variant="outlined"
                          />
                        ))}
                    </Box>
                  </Typography>
                  <Typography variant="body2">
                    <strong>Pet Policy:</strong>{' '}
                    <Chip
                      label={property.petPolicy === 'yes' ? 'Allowed' : 'Not Allowed'}
                      color={property.petPolicy === 'yes' ? 'success' : 'error'}
                      size="small"
                    />
                  </Typography>
                </Stack>
              </Card>
            </Grid>
          ))}
        </Grid> */}
        <Grid container spacing={3}>
        {properties.map((property) => (
          <Grid item xs={12} md={6} lg={4} key={property._id}>
            <Card sx={{ p: 2, height: '100%', boxShadow: 2 }}>
              <Typography variant="h6" color="primary" gutterBottom>
                {property.name}
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <Stack spacing={1}>
                {/* Basic Property Details */}
             
                <Typography variant="body2">
                  <strong>Address:</strong> {property.address}, {property.city}
                </Typography>
                <Typography variant="body2">
                  <strong>Street Number:</strong> {property.streetNumber}
                </Typography>
                <Typography variant="body2">
                  <strong>Postal Code:</strong> {property.postalCode}
                </Typography>
                <Typography variant="body2">
                  <strong>Province:</strong> {property.province}
                </Typography>
                <Typography variant="body2">
                  <strong>Size:</strong> {property.size} m²
                </Typography>
                <Typography variant="body2">
                  <strong>Floor:</strong> {property.floor}
                </Typography>
                <Typography variant="body2">
                  <strong>Max Guests:</strong> {property.maxGuests}
                </Typography>
                <Typography variant="body2">
                  <strong>Manual Max Guests:</strong> {property.manualMaxGuests}
                </Typography>
                <Typography variant="body2">
                  <strong>Ownership Type:</strong> {property.ownershipType}
                </Typography>
                <Typography variant="body2">
                  <strong>Has Elevator:</strong> {property.hasElevator ? 'Yes' : 'No'}
                </Typography>
                <Typography variant="body2">
                  <strong>Has Published Listings:</strong> {property.hasPublishedListings ? 'Yes' : 'No'}
                </Typography>
                {/* <Typography variant="body2">
                  <strong>Created At:</strong> {new Date(property.createdAt).toLocaleDateString()}
                </Typography>
                <Typography variant="body2">
                  <strong>Updated At:</strong> {new Date(property.updatedAt).toLocaleDateString()}
                </Typography> */}

                {/* Amenities */}
                <Typography variant="body2">
                  <strong>Amenities:</strong>
                  <Box sx={{ mt: 1 }}>
                    {property.amenities
                      .filter((amenity) => amenity.selected)
                      .map((amenity) => (
                        <Chip
                          key={amenity._id}
                          label={amenity.name.en}
                          size="small"
                          sx={{ mr: 1, mb: 1 }}
                          color="primary"
                          variant="outlined"
                        />
                      ))}
                  </Box>
                </Typography>

                {/* Pet Policy */}
                <Typography variant="body2">
                  <strong>Pet Policy:</strong>{' '}
                  <Chip
                    label={property.petPolicy === 'yes' ? 'Allowed' : 'Not Allowed'}
                    color={property.petPolicy === 'yes' ? 'success' : 'error'}
                    size="small"
                  />
                </Typography>

                {/* Beds */}
                <Typography variant="body2">
                  <strong>Beds:</strong> {property.beds.length > 0 ? property.beds.join(', ') : 'None'}
                </Typography>

                {/* Listings */}
                <Typography variant="body2">
                  <strong>Listings:</strong>
                </Typography>
                <Typography variant="body2" sx={{ pl: 2 }}>
                  <strong>Airbnb:</strong> {property.listings.airbnb || 'N/A'}
                </Typography>
                <Typography variant="body2" sx={{ pl: 2 }}>
                  <strong>Booking:</strong> {property.listings.booking || 'N/A'}
                </Typography>
                <Typography variant="body2" sx={{ pl: 2 }}>
                  <strong>Agoda:</strong> {property.listings.agoda || 'N/A'}
                </Typography>
                <Typography variant="body2" sx={{ pl: 2 }}>
                  <strong>Other:</strong> {property.listings.other || 'N/A'}
                </Typography>

                {/* Cadastral Info */}
                <Typography variant="body2">
                  <strong>Cadastral Info:</strong>
                </Typography>
                <Typography variant="body2" sx={{ pl: 2 }}>
                  <strong>APE:</strong> {property.cadastralInfo.ape}
                </Typography>
                <Typography variant="body2" sx={{ pl: 2 }}>
                  <strong>Cadastral Income:</strong> {property.cadastralInfo.cadastralIncome}
                </Typography>
                <Typography variant="body2" sx={{ pl: 2 }}>
                  <strong>Cadastral Section:</strong> {property.cadastralInfo.cadastralSection}
                </Typography>
                <Typography variant="body2" sx={{ pl: 2 }}>
                  <strong>Category:</strong> {property.cadastralInfo.category}
                </Typography>
                <Typography variant="body2" sx={{ pl: 2 }}>
                  <strong>Commune Code:</strong> {property.cadastralInfo.communeCode}
                </Typography>
                <Typography variant="body2" sx={{ pl: 2 }}>
                  <strong>Energy Class:</strong> {property.cadastralInfo.energyClass}
                </Typography>
                <Typography variant="body2" sx={{ pl: 2 }}>
                  <strong>Particle:</strong> {property.cadastralInfo.particle}
                </Typography>
                <Typography variant="body2" sx={{ pl: 2 }}>
                  <strong>Sheet:</strong> {property.cadastralInfo.sheet}
                </Typography>
                <Typography variant="body2" sx={{ pl: 2 }}>
                  <strong>Subordinate:</strong> {property.cadastralInfo.subordinate}
                </Typography>

                {/* CIN and CIS */}
                <Typography variant="body2">
                  <strong>CIN:</strong> {property.cin}
                </Typography>
                <Typography variant="body2">
                  <strong>CIS:</strong> {property.cis}
                </Typography>
                <Typography variant="body2">
                  <strong>CIN/CIS Document:</strong>
                </Typography>
                
               
                  {property.cinCisDocument?.map((imgName, index) => (
                    <a
                      key={index}
                      href={`${appConfig.FILE_URL}${imgName}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ marginRight: '8px', color: 'blue', textDecoration: 'underline' }} // optional styling
                    >
                      Link
                    </a>
                  ))}
                 
              

                {/* Visura Catastale */}
                <Typography variant="body2">
                  <strong>Visura Catastale:</strong> 
                </Typography>
                {property.visuraCatastale?.map((imgName, index) => (
                    <a
                      key={index}
                      href={`${appConfig.FILE_URL}${imgName}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ marginRight: '8px', color: 'blue', textDecoration: 'underline' }} // optional styling
                    >
                      Link
                    </a>
                  ))}
                <Typography variant="body2">
                  <strong>Visura Catastale Info:</strong>
                </Typography>
                <Typography variant="body2" sx={{ pl: 2 }}>
                  <strong>Data Visura:</strong> {property.visuraCatastaleInfo.dataVisura}
                </Typography>
                <Typography variant="body2" sx={{ pl: 2 }}>
                  <strong>Numero Visura:</strong> {property.visuraCatastaleInfo.numeroVisura}
                </Typography>

                {/* Rental Contract */}
                <Typography variant="body2">
                  <strong>Rental Contract:</strong> {property.rentalContract.length > 0 ? property.rentalContract.join(', ') : 'None'}
                </Typography>
              </Stack>
            </Card>
          </Grid>
        ))}
      </Grid>
      </Container>
    </>
  );
};

export default ContractDetail;
